module.exports = __webpack_public_path__ + "img/accuffr_angio.bd605fdf.png";